import React, { useState } from "react";
import "./OpiniaoUsuario.css";

const OpiniaoUsuario = () => {
  const [mensagem, setMensagem] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!mensagem.trim()) {
      setError("Por favor, escreva sua opinião.");
      return;
    }

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/enviar_feedback.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mensagem }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Obrigado pelo seu feedback!");
        setMensagem(""); // Limpa o campo após o envio
      } else {
        setError(data.error || "Erro ao enviar feedback.");
      }
    } catch (err) {
      setError("Erro ao conectar ao servidor.");
    }
  };

  return (
    <div className="opiniao-text">
    <h1>Opinião do Usuário</h1>
    <div className="opiniao-container">
  
      <p className="intro-text">
  Sua opinião é muito importante para melhorarmos o sistema! Deixe aqui suas sugestões, críticas ou elogios de forma anônima.
<br></br><br></br><br></br></p>

<ul className="sugestoes-perguntas">
  <li>💡O que você mais gosta no sistema?</li>
  <li>💡O que poderia ser melhorado?</li>
  <li>💡Encontrou alguma dificuldade ao usar o sistema?</li>
  <li>💡Qual funcionalidade você gostaria de ver no futuro?</li>
</ul>

      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}

      <form onSubmit={handleSubmit}>
        <textarea
          name="mensagem"
          placeholder="Escreva aqui sua sugestão, crítica ou elogio..."
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
          required
        />
        <button type="submit">Enviar</button>
      </form>
    </div>
    </div>
  );
};

export default OpiniaoUsuario;
